import React from 'react';
import { motion } from 'framer-motion';

const DEVELOPER_DISPLAY_NAME = 'Önder Yılmaz';
const letters = Array.from(DEVELOPER_DISPLAY_NAME);

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.065,
      delayChildren: 0.08,
      when: 'beforeChildren',
    },
  },
};

const charVariants = {
  hidden: {
    opacity: 0,
    y: 48,
    rotateX: -88,
    scale: 0.55,
    filter: 'blur(10px)',
  },
  visible: {
    opacity: 1,
    y: 0,
    rotateX: 0,
    scale: 1,
    filter: 'blur(0px)',
    transition: {
      type: 'spring',
      stiffness: 420,
      damping: 20,
      mass: 0.45,
    },
  },
};

/**
 * Modal içinde "Önder Yılmaz" için harf harf 3D yaylı animasyon.
 */
const DeveloperNameAnimated = () => (
  <div className="developer-about-name-wrap">
    <motion.p
      className="developer-about-name developer-about-name--animated"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
      aria-label={DEVELOPER_DISPLAY_NAME}
    >
      {letters.map((char, i) => (
        <motion.span
          key={`${i}-${char}`}
          className="developer-about-char"
          variants={charVariants}
          style={{ display: 'inline-block', transformStyle: 'preserve-3d' }}
        >
          {char === ' ' ? '\u00A0' : char}
        </motion.span>
      ))}
    </motion.p>
  </div>
);

export default DeveloperNameAnimated;
